<template>
  <!-- <div class="swiper-container" :id="'swiper-con' + blockData.id" :style="types == 'gzkh' ? 'overflow:unset' : ''"> -->
  <div class="swiper-container" :id="'swiper-con' + blockData.id">
    <ul class="clearfix swiper-wrapper">
      <li class="fl swiper-slide" v-for="(ite, ind) in contentDatas" @contextmenu="$emit('emitContextMenuItem', ind, $event, ite)" @click="handleDetail(ite)" :key="ind">
        <a href="javascript:;" class="followMembers" v-if="types == 'gzkh'" @contextmenu.stop.prevent="" @click.stop.prevent="jumpFlow(ite)">
          <ZImage :value="ite.logoUrl ? ite.logoUrl : ''" :error-src="require('../assets/image/images/default_media.png')" />
          <followMembers :ite="ite" :user-id="userId" :pf-id="pfId"></followMembers>
        </a>
        <a href="javascript:;" v-else>
          <special-offer :ite="ite" @removeCon="removeCon"></special-offer>
          <ZImage :value="ite.pictures.length ? ite.pictures[0] : ''" :error-src="require('../assets/image/images/default_media.png')" />
          <div class="li_hover" @click.stop="handleDetail(ite, 'newDetail')">
            <p class="li_hover_title">
              <span>{{ ite.others.length && ite.others[0].standardData ? ite.others[0].standardData : '' }}</span>
              <span>{{ ite.appName ? ite.appName : '' }}</span>
            </p>
            <div class="li_hover_conter">
              <div class="label-box" v-if="ite.others">
                <div class="label-set" v-for="(tag, tin) in filterJCPrice(ite.tags)" :key="tin" v-show="tag.standardData && tag.standardName != '产品标识' && tag.standardEnName != 'productMarking' && !isUrl(tag.standardData)">
                  <span>{{ tag.standardName ? tag.standardName + '：' : '' }}</span
                  >{{ allPrice(tag.standardEnName) ? formatPrice(tag.standardData) : tag.standardData }}
                </div>
              </div>
            </div>
          </div>
        </a>
      </li>
    </ul>
    <div class="arrow-left" v-if="!types"></div>
    <div class="arrow-right" @click="arrowRight()"></div>
  </div>
</template>
<script>
import CountDown from '../components/CountDown.vue'
import SpecialOffer from '../components/specialOffer.vue'
import followMembers from '../components/followMembers.vue'
import ZImage from './ZImage.vue'
export default {
  name: 'haowu',
  components: {
    ZImage,
    CountDown,
    SpecialOffer,
    followMembers
  },
  props: {
    contentData: {
      type: Array
    },
    blockData: {
      type: Object
    },
    types: {
      type: String
    },
    pageSize: Number,
    newBanner: Boolean
  },
  inject: ['seckill', 'member'],
  data() {
    return {
      mySwiper: undefined,
      preNum: 5,
      pageNum: 1,
      contentDatas: [],
      pfId: window.$pfId,
      userId: this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : '',
      seckillShow: true
    }
  },

  mounted() {
    if (!this.contentData.length) {
      this.contentDatas = [
        { others: [{ standardData: '' }], tags: [{ standardData: '' }], pictures: [] },
        { others: [{ standardData: '' }], tags: [{ standardData: '' }], pictures: [] },
        { others: [{ standardData: '' }], tags: [{ standardData: '' }], pictures: [] },
        { others: [{ standardData: '' }], tags: [{ standardData: '' }], pictures: [] },
        { others: [{ standardData: '' }], tags: [{ standardData: '' }], pictures: [] }
      ]
    } else {
      this.contentDatas = this.contentData
    }
    if (this.pageSize) {
      this.getSeckill(1, this.pageSize)
    }
    this.swiperFn()
  },
  watch: {
    contentData: function (val) {
      if (!this.pageSize) {
        if (val.length) {
          this.contentDatas = val
          this.$nextTick(() => {
            this.swiperFn()
          })
        } else {
          this.contentDatas = [
            { others: [{ standardData: '' }], tags: [{ standardData: '' }], pictures: [] },
            { others: [{ standardData: '' }], tags: [{ standardData: '' }], pictures: [] },
            { others: [{ standardData: '' }], tags: [{ standardData: '' }], pictures: [] },
            { others: [{ standardData: '' }], tags: [{ standardData: '' }], pictures: [] },
            { others: [{ standardData: '' }], tags: [{ standardData: '' }], pictures: [] }
          ]
        }
      }
    },
    seckill: {
      handler(value) {
        if (value) {
          this.swiperFn()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    jumpFlow(ite) {
      var ua = navigator.userAgent.toLowerCase() //获取判断用的对象
      if (ua.indexOf('Electron') > -1) {
        var ipcRender = top.window.ipcRender ? top.window.ipcRender : top.window.require('electron').ipcRenderer
        var data = { title: ite.appName, url: ite.url }
        ipcRender.send('openWindow', data)
      } else {
        var iOSIs = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
        if (ua.match(/cmeplaza/i) == 'cmeplaza' && iOSIs) {
          window.location.href = ite.url
        } else {
          window.open(ite.url, '_blank')
        }
      }
    },
    getSeckill(size, num) {
      var _this = this
      var aassid = _this.getQuery('assetId')
      var url = '/zciid-deliverable/showPlatformStyle/flow/api/getConfigContentByAppId.json',
        data = { appId: _this.$appId, pageNum: size, pageSize: num, types: this.types, supContentId: this.$contentId, floorEnName: _this.blockData.flowEnName }
      if (_this.types == 'zycp') {
        //主营产品单独处理
        url = '/zciid-deliverable/api/showPlatform/content/getFlowContentByBlockId.json'
        data = { appId: _this.$appId, blockId: _this.getQuery('blockId'), pageNum: size, pageSize: num }
      }
      if (aassid && _this.types == 'zycp') {
        //数据楼层单独处理
        url = '/zciid-deliverable/api/webapp/app/relation/get/dataAsset.json'
        data = { appId: _this.$appId, flowId: _this.getQuery('blockId'), pageNum: size, pageSize: num }
      } else if (aassid) {
        //数据楼层单独处理
        url = '/zciid-deliverable/api/webapp/app/relation/getAssetRelatedData.json'
        data = { appId: _this.$appId, assetId: aassid, pfId: _this.getQuery('pfId'), pcode: _this.getQuery('pcode'), types: _this.types, pageNum: size, pageSize: num }
      }
      if (_this.types == 'gzkh') {
        //关注客户单独处理
        url = '/zciid-deliverable/api/app/followers/audienceInsights.json'
        data = { pfId: window.$pfId, userId: _this.userId, pageNum: size, pageSize: num }
      }
      if (_this.types == 'xgzx') {
        //关注客户单独处理
        url = '/zciid-deliverable/api/showPlatform/content/getWzZxData.json'
        data = { appId: _this.$appId, contentId: _this.$contentId, pageNum: size, pageSize: num }
      }
      _this.$http.get(url, data).then((res) => {
        if (res.state == 1 && (res.data.length || (res.data.list && res.data.list.length) || (res.data.contentJsonArr && res.data.contentJsonArr.length))) {
          if (_this.types == 'gzkh') {
            _this.contentDatas = res.data.list
            return
          }
          if (aassid && _this.types != 'xgzx') {
            var arr = [],
              arrays = res.data.list || res.data
            arrays.forEach((ele) => {
              var newObject = {}
              newObject.appId = this.getQuery('wzAppId')
              newObject.appName = ele.pfName
              newObject.nodeId = ''
              newObject.contentId = ele.contentId
              newObject.contentRows = ''
              newObject.contentShowFlowPosition = ''
              newObject.contentShowRowsSort = ''
              newObject.sceneGroupId = ''
              newObject.sceneId = ''
              newObject.isYyz = 0
              newObject.userId = ''
              newObject.contentWzUrl = ele.url
              newObject.blockDataType = ''
              newObject.releaseId = ''
              newObject.sign = ''
              newObject.standardJson = [
                { standardName: '资产名称', standardData: ele.name, standardEnName: 'appName', appId: this.getQuery('wzAppId'), appName: ele.pfName },
                { standardName: '简介', standardData: ele.intro },
                { standardName: '组织身份', standardData: ele.pfName },
                { standardName: '资产交易价', standardEnName: 'assetsPrice', standardData: ele.assetsPrice + '/' + (ele.assetsUnit ? ele.assetsUnit : '') },
                { standardName: '定期租赁价', standardEnName: 'periodicPrice', standardData: ele.periodicPrice + '/' + (ele.periodicUnit ? ele.periodicUnit : '') },
                { standardName: '次数租赁价', standardEnName: 'timesPrice', standardData: ele.timesPrice + '/' + (ele.timesUnit ? ele.timesUnit : '') },
                { standardName: '图片', standardData: this.$store.state.baseURL + `/cme-sso-app/showimg/${JSON.parse(ele.logo)[0].id}.png`, fileTypeDetail: 2, appName: ele.pfName }
              ]
              arr.push(newObject)
            })
            res.data = arr
          }
          var array = [],
            arrs = res.data.contentJsonArr ? res.data.contentJsonArr : res.data
          arrs.forEach((item) => {
            var tags = [],
              pictures = [],
              others = [],
              btns = [],
              contentId = '',
              blockId = ''
            contentId = item.contentId
            blockId = item.blockId
            item.standardJson.forEach((ele) => {
              if (ele.standardData && (ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0 || ele.standardData.indexOf('.jpeg') > 0 || ele.fileTypeDetail == '2')) {
                pictures.push(ele.standardData)
              } else {
                others.push(ele)
              }
            })

            array.push({
              appId: item.appId,
              appName: item.appName,
              contentId: contentId,
              blockId: blockId,
              nodeId: item.nodeId,
              contentDsfWzUrl: item.contentDsfWzUrl,
              pictures: pictures,
              others: others,
              btns: btns,
              sign: item.sign,
              tags: item.standardJson,
              endTime: item.endTime,
              contentWzUrl: item.contentWzUrl,
              discountTypes: item.discountTypes,
              priceType: item.priceType,
              changeData: item.changeData,
              spellData: item.spellData,
              spellText: item.spellText,
              giveData: item.giveData,
              giveText: item.giveText,
              ordinaryPrice: item.ordinaryPrice,
              silverPrice: item.silverPrice,
              goldprice: item.goldprice,
              platinumPrice: item.platinumPrice,
              diamondsPrice: item.diamondsPrice,
              blackGoldprice: item.blackGoldprice,
              memberEndTime: item.memberEndTime
            })
          })
          _this.contentDatas = array
          if (_this.types == 'xgzx') {
            console.log(array);

          }
          
        } else {
          this.$emit('hiddenFloor', _this.types)
        }
      })
    },
    removeCon(contentId) {
      if (!this.newBanner) {
        //好物推荐和详情页竖向列表秒杀结束去除右上角,其他删除交付物
        var ind = this.contentDatas.findIndex((tag) => tag.contentId == contentId)
        this.contentDatas.splice(ind, 1)

        if (!this.contentDatas.length) {
          this.$emit('seckillShow')
        }
      }
    },
    //跳转详情页
    handleDetail(ite, data) {
      this.$blockGetData.handleDetail(this, ite, this.blockData.flowEnName)
    },
    //轮播图
    swiperFn() {
      var _this = this
      _this.preNum = 5
      if (!document.getElementById('app').style.transform) {
        if (window.innerWidth > 768 && window.innerWidth <= 1000) {
          _this.preNum = 4
        }
      }
      if (window.innerWidth <= 768) {
        _this.preNum = 2
      }
      _this.$nextTick(() => {
        _this.mySwiper = new Swiper('#swiper-con' + _this.blockData.id, {
          navigation: {
            nextEl: '.arrow-right',
            prevEl: '.arrow-left'
          },
          observer: true, //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true,
          spaceBetween: 12,
          slidesPerView: _this.preNum,
          slidesPerGroup: _this.preNum,
          on: {
            touchEnd: function (swiper, event) {
              if (_this.mySwiper.isEnd && _this.mySwiper.swipeDirection == 'next') {
                _this.arrowRight()
              }
            }
          }
        })
        if (_this.mySwiper && _this.pageNum != 1 && !_this.mySwiper[0]) {
          _this.mySwiper.slideTo((_this.pageNum - 1) * _this.preNum)
        } else if (_this.mySwiper && _this.mySwiper[0]) {
          _this.mySwiper[0].slideTo((_this.pageNum - 1) * _this.preNum)
        }
      })
    },
    arrowRight() {
      if (this.types == 'gzkh') {
        location.href = location.origin + '/zjstatic/standard/followMembers/index.html?pfId=' + window.$pfId + '&xxx=caassid'
        return
      }
      if (this.types) {
        var data = { appId: this.getQuery('appId'), types: this.types, supContentId: this.$contentId, blockId: this.getQuery('blockId') }
        if (this.getQuery('assetId')) {
          data.assetId = this.getQuery('assetId')
          data.pcode = this.getQuery('pcode')
          data.pfId = this.getQuery('pfId')
        }
        // this.$router.push({ path: 'flowList', query: data});
        this.routerJump('push', 'flowList', data, '更多')
      }
      if (this.blockData.floorType == 'newBanner') return
      if (this.mySwiper.activeIndex == (this.pageNum - 1) * this.preNum || (this.mySwiper && this.mySwiper[0] && this.mySwiper[0].activeIndex == (this.pageNum - 1) * this.preNum)) {
        this.pageNum += 1
        this.$emit('arrowRight', this.pageNum, this.preNum)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  height: 100%;
  .followMembers {
    box-shadow: 0 1px 5px rgba(117, 116, 116, 0.4);
    .content {
      padding: 8px 12px;
    }
    img {
      height: 222px;
    }
  }
}
.swiper-container:hover .arrow-left,
.swiper-container:hover .arrow-right {
  display: block;
}
.swiper-container ul {
  width: 70%;
  height: 100%;
}

ul li {
  display: block;
  font-size: 0;
  // line-height: 108px;
  background: #fafafa;
  position: relative;
}
.arrow-left {
  z-index: 9;
  display: none;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 50%;
  margin-top: -24px;
  left: 0;
  background: url('~@/assets/images/product_detail/recommend_arrow_left.png') no-repeat center;
  cursor: pointer;
}
.arrow-right {
  z-index: 9;
  display: none;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 50%;
  margin-top: -24px;
  right: 0;
  background: url('~@/assets/images/product_detail/recommend_arrow_right.png') no-repeat center;
  cursor: pointer;
}
a {
  display: block;
  width: 100%;
  height: 100%;
  // text-align: center;
  position: relative;
}
.li_hover {
  transition: all 0.2s linear;
  width: calc(100% - 20px);
  /* // height: 100%; */
  position: absolute;
  left: 0;
  bottom: 0;
  /* // bottom: -285px; */
  background: rgba(0, 0, 0, 0.6);
  padding: 0 10px;
  z-index: 10;
  &:hover {
    transition: all 0.2s linear;
    height: 100%;
    .li_hover_title {
      padding-top: 6px;
    }
    .li_hover_conter {
      display: block;
    }
  }
}
// .li_hover_title {
//   width: 100%;
//   margin: 0;
//   font-size: 16px;
//   color: #fff;
//   height: 40px;
//   line-height: 40px;
//   /* // border-bottom: 1px dashed #bbbbbb; */
//   overflow: hidden;
//   white-space: nowrap;
//   text-overflow: ellipsis;
//   text-align: center;
// }
.li_hover_title {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  font-size: 16px;
  color: #fff;
  height: 48px;
  span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  span:nth-child(1) {
    font-size: 14px;
    color: rgb(255, 255, 255);
    padding-top: 5px;
  }
  span:nth-child(2) {
    font-size: 12px;
    color: rgb(170, 170, 170);
    padding-top: 1px;
  }
}
// .li_hover:hover {
//   transition: all 0.2s linear;
//   height: 100%;
// }
// .li_hover:hover .li_hover_conter {
//   display: block;
// }
.li_hover_conter {
  border-top: 1px dashed #bbbbbb;
  display: none;
  text-align: left;
  font-size: 14px;
  line-height: 20px;
  /* margin: 10px 0; */
  color: #fff;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 7;
  height: calc(100% - 59px);
  width: 100%;
  overflow: auto;
}
.label-box {
  width: 100%;
}
.label-set {
  height: 26px;
  line-height: 26px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media screen and (max-width: 768px) {
  .swiper-container ul {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/haowutuijian.vue